var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    [
      !_vm.isMobile && !_vm.isWhitelabel
        ? _c("header-top", {
            ref: "headerTop",
            attrs: {
              collapsed: _vm.collapsed,
              customer: _vm.customer,
              "user-logged-in": _vm.userLoggedIn
            },
            on: {
              navigate: function($event) {
                return _vm.$emit("navigate", $event)
              },
              "log-out": function($event) {
                return _vm.$emit("log-out", $event)
              }
            }
          })
        : _vm._e(),
      _vm.isMobile
        ? _c(
            "header-bottom-mobile",
            {
              attrs: {
                "is-whitelabel": _vm.isWhitelabel,
                "scrolling-up": _vm.scrollingUp,
                "hide-fixed-header": _vm.hideFixedHeader,
                "cart-route": _vm.cartRoute,
                "checkout-route": _vm.checkoutRoute,
                cart: _vm.cart,
                search: _vm.search,
                "marketplace-categories": _vm.marketplaceCategories,
                "user-logged-in": _vm.userLoggedIn,
                "is-mobile-sales-page": _vm.isMobileSalesPage,
                "current-scroll-top": _vm.currentScrollTop
              },
              on: {
                "search-input": function($event) {
                  return _vm.$emit("search-input", $event)
                },
                "perform-search": function($event) {
                  return _vm.$emit("perform-search", $event)
                },
                "open-menu": function($event) {
                  return _vm.toggleMenu(true)
                },
                "log-out": function($event) {
                  return _vm.$emit("log-out", $event)
                }
              }
            },
            [_vm._t("logo")],
            2
          )
        : [
            _c(
              "header-bottom",
              {
                ref: "headerBottom",
                attrs: {
                  "is-whitelabel": _vm.isWhitelabel,
                  "hide-fixed-header": _vm.hideFixedHeader,
                  "cart-route": _vm.cartRoute,
                  "checkout-route": _vm.checkoutRoute,
                  cart: _vm.cart,
                  search: _vm.search,
                  "marketplace-categories": _vm.marketplaceCategories,
                  "user-logged-in": _vm.userLoggedIn,
                  "show-home-link": _vm.showHomeLink
                },
                on: {
                  "search-input": function($event) {
                    return _vm.$emit("search-input", $event)
                  },
                  "perform-search": function($event) {
                    return _vm.$emit("perform-search", $event)
                  },
                  "log-out": function($event) {
                    return _vm.$emit("log-out", $event)
                  }
                }
              },
              [_vm._t("logo")],
              2
            ),
            _c(
              "header-bottom",
              {
                ref: "headerBottomFixed",
                attrs: {
                  fixed: "fixed",
                  "is-whitelabel": _vm.isWhitelabel,
                  "hide-fixed-header": _vm.hideFixedHeader,
                  collapsed: _vm.collapsed,
                  "cart-route": _vm.cartRoute,
                  "checkout-route": _vm.checkoutRoute,
                  cart: _vm.cart,
                  search: _vm.search,
                  "marketplace-categories": _vm.marketplaceCategories,
                  "user-logged-in": _vm.userLoggedIn,
                  "show-home-link": _vm.showHomeLink
                },
                on: {
                  "search-input": function($event) {
                    return _vm.$emit("search-input", $event)
                  },
                  "perform-search": function($event) {
                    return _vm.$emit("perform-search", $event)
                  },
                  "log-out": function($event) {
                    return _vm.$emit("log-out", $event)
                  }
                }
              },
              [_vm._t("logo")],
              2
            )
          ],
      _c(
        "header-menu",
        {
          attrs: {
            open: _vm.menuOpen,
            links: _vm.menuLinks,
            "user-logged-in": _vm.userLoggedIn,
            search: _vm.search,
            "is-whitelabel": _vm.isWhitelabel
          },
          on: {
            "close-menu": function($event) {
              return _vm.toggleMenu(false)
            },
            navigate: function($event) {
              return _vm.$emit("navigate", $event)
            },
            "log-out": function($event) {
              return _vm.$emit("log-out", $event)
            },
            "search-input": function($event) {
              return _vm.$emit("search-input", $event)
            },
            "perform-search": function($event) {
              return _vm.$emit("perform-search", $event)
            }
          }
        },
        [_vm._t("social")],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }